//@ts-nocheck

import React from "react";

import * as S from './CardNews.styles';

import { Paragraph, Heading } from '../../atoms/Typography/Typography.component';
import { SpacerBase } from "../../atoms/GridSystem";
import LinkWrapper from '../../atoms/LinkWrapper/LinkWrapper.component';

import Image from 'next/image'

const CardNews = ({ href, title, date, image, site, categories = [], parentColorScheme, withBackground }) => {

  return (
    <LinkWrapper href={href}>
      <S.CardNews colorScheme={parentColorScheme} withBackground={withBackground}>
        <S.CardNewsImage>
          <Image src={image?.url} alt={image?.alt} fill/>
        </S.CardNewsImage>
        <SpacerBase xs={3} />
        <Paragraph content={date} typo={'paragraphMD'} uppercase/>
        <SpacerBase xs={3} />
        <Heading content={title} typo={'headingMD'} weight={'regular'} />
        <SpacerBase xs={2} />
        {/* <Paragraph content={site} typo={'paragraphMD'} uppercase/> */}
        { categories.length > 0 ? (
          <S.CardNewsCategories>
            {categories.map((category) => (
              <S.CardNewsCategory key={category.id} color={category.colorCategory}>
                <Paragraph content={category.title} typo={'paragraphMD'} uppercase/>
              </S.CardNewsCategory>
            ))}
          </S.CardNewsCategories>
        ) : null}
      </S.CardNews>
    </LinkWrapper>
  );
};

export default CardNews;
